var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/empty_bag.3a94e564.png","uri@2x": __webpack_public_path__ + "static/media/empty_bag.67d9c1c1.png","uri@3x": __webpack_public_path__ + "static/media/empty_bag.fba6f542.png",
    width: 58,
    height: 54
});